import { Link } from "react-router-dom";
import { TRIBE_ROLE_CHIPS } from "../data/tribeRoles.js";
import { SectionMeta } from "../components/SectionMeta.jsx";

const WANTS = [
  "Meaningful work over busywork.",
  "Flexible lives over rigid hours.",
  "Smarter collaboration over louder rooms.",
  "Purpose over politics.",
  "Freedom over structure.",
];

export function Idea() {
  return (
    <section className="section shell" id="idea">
      <SectionMeta num="§ 02" label="Hello" right="The idea, in plain words" />

      <h2 className="h-large reveal">
        Say hello to <em>Alt Tribe.</em>
      </h2>

      <div className="idea-roles reveal idea-roles-top" aria-label="Who the tribe is for">
        {TRIBE_ROLE_CHIPS.map((role) => (
          <span key={role.label} className={"chip " + (role.variant || "")}>
            {role.label}
          </span>
        ))}
        <Link to="/apply" className="chip chip-muted chip-link">
          + you?
        </Link>
      </div>

      <div className="idea-grid idea-grid-top">
        <div className="reveal">
          <p className="lead lead-flush">
            A high-performing tribe of people who refuse to settle for the
            version of work everyone else accepted.
          </p>
          <p className="body body-serif">
            We believe the future belongs to smaller teams, sharper minds,
            deeper collaboration — and people who know how to work{" "}
            <em className="accent-em">with</em> AI, not fear it.
          </p>
        </div>

        <div className="reveal">
          <div className="mono label-muted">What they want</div>
          <ul className="idea-want">
            {WANTS.map((text, i) => (
              <li key={text}>
                <span className="n">{String(i + 1).padStart(2, "0")}</span>
                <span className="t">{text}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
